<template>
  <div class="page-content">
    <page-template
      ref="memberCategoryTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog
      :title="selectRow.id ? '编辑会员类别' : '添加会员类别'"
      :visible.sync="dialogVisibility"
      center
      custom-class="category-dialog"
      width="1200px"
      height="800"
    >
      <el-form :model="formModel" :rules="formRule" v-if="dialogVisibility" ref="form">
        <el-row>
          <el-col :span="24">
            <div class="title">基本信息设置</div>
          </el-col>
          <template v-for="(column, index) in addColumns.columns">
            <el-col
              v-if="column.hidden == true ? false : true"
              :span="12"
              :key="index"
            >
              <el-form-item
                :label="column.label"
                :prop="column.prop"
                :class="[{ 'is-required': column.specialRule }, column.class]"
                :label-width="column.labelWidth || addColumns.labelWidth"
                :error="column.error"
                :style="column.style"
              >
                <!--输入框-->
                <el-input
                  autocomplete="off"
                  v-if="column.type === columnType.input"
                  v-model="formModel[column.prop]"
                  @change="valueChange(column)"
                  :maxlength="column.maxLength"
                  :minlength="column.minlength"
                  :placeholder="column.placeholder"
                  :disabled="column.disabled || false"
                ></el-input>

                <!--数字输入框-->
                <el-input-number
                  autocomplete="off"
                  v-else-if="column.type === columnType.inputNumber"
                  v-model="formModel[column.prop]"
                  :disabled="column.disabled || false"
                  :placeholder="column.placeholder"
                  @change="valueChange(column)"
                  :precision="column.precision || undefined"
                  :min="column.min || undefined"
                  :max="column.max || undefined"
                ></el-input-number>

                <!--文本域-->
                <el-input
                  type="textarea"
                  v-else-if="column.type === columnType.textarea"
                  :placeholder="column.placeholder"
                  v-model="formModel[column.prop]"
                  :maxlength="column.maxLength"
                  :disabled="column.disabled || false"
                ></el-input>

                <!--下拉框-->
                <el-select
                  :class="{ 'multiple-select': column.multiple }"
                  v-else-if="column.type === columnType.select"
                  v-model="formModel[column.prop]"
                  placeholder="请选择"
                  @change="valueChange(column)"
                  :multiple="column.multiple || false"
                  :collapse-tags="column.collapseTags || false"
                  :disabled="column.disabled || false"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in column.data"
                    :key="item[column.uniqueKey] || item.value || item.id"
                    :label="item[column.labelKey] || item.label || item.name"
                    :title="item[column.labelKey] || item.label || item.name"
                    :value="item[column.uniqueKey] || item.value || item.id"
                  ></el-option>
                </el-select>
                <el-switch
                  v-else-if="column.type === columnType.switch"
                  v-model="formModel[column.prop]"
                  @change="valueChange(column)"
                ></el-switch>
                <be-code
                  :ref="column.prop"
                  :column="column"
                  :disabled="column.disabled || false"
                  v-else-if="column.type === columnType.code"
                ></be-code>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <participation-goods ref="participationGoods"></participation-goods>
      </el-form>
      <div class="footerBtn">
        <el-button type="primary" @click="submitData()">保存</el-button>
        <el-button type="default" @click="reset()">重置</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import api from "@/config/api";
  import userPower from "@/mixin/userPower";
  import listTemplate from "@/components/template/listTemplate.vue";
  import beCode from "@/components/controls/beCode";
  import participationGoods from "@/components/business/participationGoods"

  export default {
  mixins: [userPower],
  components: {
    pageTemplate,
    beCode,
    listTemplate,
    participationGoods
  },
  data() {
    return {
      formRule: {},
      columnType: this.$utils.columnType,
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '类别名称/编码',
            prop: 'otherName',
            type: 'input',
            isFuzzy: true,
            placeholder: '请输入类别名称/编码',
            labelWidth: '110'
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
          callback: this.insert,
          filter:()=>{
            return this.$utils.getSysUser().storeId?false:true
          }
        },
        {
          label: "同步",
          code: "sync",
          callback: this.sync,
          filter:()=>{
            return false
          }
        },
        {
          label: "编辑",
          type: this.$utils.buttonType.tableOperate,
          code: "update",
          filter:()=>{
            return this.$utils.getSysUser().storeId?false:true
          },
          callback: this.update,
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
          filter:()=>{
            return this.$utils.getSysUser().storeId?false:true
          }
        },
      ],
      // 表格信息配置
      tableOptions: {
        // showSelect: true,
        indexShow: true,//是否显示索引
        columns: [
          {
            label: "会员类别名称",
            prop: "name",
            width: "120",
            align: "center",
          },
          {
            label: "会员类别编码",
            prop: "code",
            width: "120",
            align: "center",
          },
          {
            label: "优惠方式",
            prop: "discountType",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus(
              "mbMemberCategory.discountType"
            ),
          },
          {
            label: "折扣率",
            prop: "discountRate",
            width: "100",
            align: "center",
          },
          {
            label: "是否积分",
            prop: "generateIntegral",
            width: "120",
            align: "center",
            selfData: true,//自定义值转化
          },
          {
            label: "是否储值",
            prop: "deposit",
            width: "120",
            align: "center",
            selfData: true,//自定义值转化
          },
          // {
          //   label: "赠送金额",
          //   prop: "giving_money",
          //   width: "120",
          //   align: "center",
          // },
          // {label: "创建人", prop: "createBy", width: "100", align: "center"},
          {
            label: "创建时间",
            prop: "createDttm",
            width: "150",
            align: "center",
          },
          {label: "备注", prop: "remarks", width: "120", align: "center"},
        ],
        url: api.member.category,
      },
      // 添加字段
      addColumns: {
        labelWidth: "120px",
        span: 12,
        columns: [
          {
            label: "类别编码",
            type: "input",
            prop: "code",
            isButtonShow: false,
            disabled:true,
            checkUrl: api.member.category + "/check/code",
            rule: [
              {
                required: true,
                message: "请输入会员类型编码",
                trigger: "blur",
              },
            ],
          },
          {
            label: "类别名称",
            type: "input",
            prop: "name",
            maxLength: 16,
            change: this.checkNane,
            rule: [
              {
                required: true,
                message: "请输入会员类别名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "优惠方式",
            type: "select",
            prop: "discountType",
            data: this.$utils.getCacheStatus("mbMemberCategory.discountType"),
            change: this.hide,
            rule: [
              {
                required: true,
                message: "请选择优惠方式",
                trigger: "change",
              },
            ],
          },
          {
            label: "折扣率(0~1)",
            type: "inputNumber",
            prop: "discountRate",
            max: 1,
            min: 0.0001,
            hidden: true,
            rule: [
              {required: true, message: "请输入折扣率", trigger: "blur"},
            ],
          },
          {
            label: "允许积分",
            type: "switch",
            prop: "generateIntegral",
            span: 24,
          },
          {
            label: "允许储值",
            type: "switch",
            prop: "deposit"
          },
          // {
          //   label: "赠送金额",
          //   prop: "giving_money",
          //   type: "inputNumber",
          //   span: 24,
          // },
          {
            label: "备注",
            type: "textarea",
            prop: "remarks",
            maxLength: 16,
            isAllline: true,
          },
        ], // 表单label
        url: api.member.category,
      },
      formModel:{},
      // formModel: {
      //   code: "",
      //   deposit: false,
      //   discountRate: "",
      //   discountType: "",
      //   generateIntegral: false,
      //   giving_money: 0,
      //   name: "",
      //   remarks: ""
      // },
      selectRow: {},
    };
  },
  created() {
    console.log(this.$utils.getSysUser().relateType)
    // this.setStore(this.searchOptions.simple);
    this.addColumns.columns.map(column => {

      this.$set(this.formRule, column.prop, column.rule || []);
      if (column.type === 'switch') {
        this.$set(this.formModel, column.prop, false);
      } else if (column.type === 'inputNumber') {
        this.$set(this.formModel, column.prop, undefined);
      } else {
        this.$set(this.formModel, column.prop, "");
      }
    });
  },
  methods: {
    // 名称验重
    checkNane(row){
      console.log(this.selectRow.name)
      if(this.dialogType === 'edit'){
        if(this.selectRow.name !== row.name){
          console.log(row.name)
          this.changeNameSure(row,this.selectRow.name)
        }
      }else{
        this.changeNameSure(row,'')
      }
    },
    changeNameSure(row,oldName){
      this.$axios.fetchPost(api.member.checkMemberName,{name:row.name}).then((res) => {
        if (res.code === 200) {
          if(!res.data){
            this.$message.warning('会员类别名称重复')
            row.name = oldName
          }
        }else{
          this.$message.error(res.errorMsg)
          row.name = oldName
        }
      }).finally(()=>{})
    },
    submitData() {
      let participationGoodsData = this.$refs.participationGoods.getAllData();
      this.formModel = {...this.formModel, ...participationGoodsData};
      this.$refs.form.validate(valid=>{
        if(valid){
          this.$loading({text:'提交中，请稍后。。。'})
          this.$axios[this.selectRow.id ? 'fetchPut' : 'fetchPost'](api.member.category, this.formModel).then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.$notify({
                type: "success",
                title: (this.selectRow.id ? '编辑' : '添加') + '操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: (this.selectRow.id ? '编辑' : '添加') + '成功!'});
              this.dialogVisibility = false;
              this.$refs.memberCategoryTemplate.getData()//刷新列表
              // this.$emit('success');
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).finally(()=>{
            this.$loading({}).close()
          })
        }else{
          return false
        }
      })

    },
    reset(){
    },
    valueChange(column) {
      column.change && column.change(this.formModel);
    },
    insert() {
      this.dialogType = 'add'
      this.addColumns.columns.filter(v=>v.prop === 'name')[0].disabled = false
      this.addColumns.columns.map(column => {
        if(column.prop==='code'){
          column.hidden = true
        }
        this.$set(this.formRule, column.prop, column.rule || []);
        if (column.type === 'switch') {
          this.$set(this.formModel, column.prop, false);
        } else if (column.type === 'inputNumber') {
          this.$set(this.formModel, column.prop, undefined);
        } else {
          this.$set(this.formModel, column.prop, "");
        }
      });
      this.selectRow = {};
      this.dialogVisibility = true;
    },
    // 编辑
    update(row) {
      this.dialogType = 'edit'
      let categoryName = this.addColumns.columns.filter(v=>v.prop === 'name')[0]
      this.addColumns.columns.filter(v=>v.prop === 'code')[0].hidden = false
      this.$axios
        .fetchGet(api.member.category + "?id=" + row.id)
        .then((data) => {
          if (data.code === 200 && data.data) {
            //系统默认的会员类别的名称不允许修改
            if(data.data.systemGenerate){
              categoryName.disabled = true
            }else{
              categoryName.disabled = false
            }
            this.selectRow = this.$utils.deepClone(data.data);
            this.dialogVisibility = true;
            this.formModel = data.data;
            this.$nextTick(() => {
              this.addColumns.columns.map(column=>{
                  column.change && column.change(this.formModel);
              });
              //this.$refs.code[0].setValue(this.formModel);
              this.$refs.participationGoods.setValue(this.formModel);
            });
          } else {
            this.$message({message: "获取详情出错", type: "error"});
          }
        })
    },
    sync() {
      // 门店集合
      let ids = this.$refs.memberCategoryTemplate.getSimpleParams().storeId;
      if (!ids) {
        this.$message({message: "请选择门店后进行同步", type: "warning"});
        return;
      }
      // 需要同步的数据
      let tableRows = this.$refs.memberCategoryTemplate.getTableSelectRow();
      if (tableRows.length === 0) {
        this.$message({message: "请勾选一条数据后进行同步", type: "warning"});
        return;
      }
      this.$axios
        .fetchPost(api.member.category + "/sync", {
          categoryList: tableRows,
          ids: ids,
        })
        .then((data) => {
          if (data.code === 200 && data.data) {
            this.$notify({
              type: "success",
              title: '同步操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: "同步成功", type: "success"});
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          this.$message({message: "请求失败！", type: "error"});
        });
    },
    hide(form) {
      if (form.discountType == "10" || form.discountType == "30") {
        this.addColumns.columns[3].hidden = true;
      } else {
        this.addColumns.columns[3].hidden = false;
        this.addColumns.columns[3].rule[0].required = true;
      }
    },
  },
};
</script>

<style scoped>
.title {
  height: 20px;
  line-height: 20px;
  background-color: #efefef;
  padding: 10px;
  box-sizing: content-box;
  border-radius: 5px;
  padding-left: 20px;
  margin-bottom: 20px;
}

.col-span {
  margin-top: 20px;
}
>>> .el-table th>.cell{
  height:30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/page/member/Category.vue